import { render, staticRenderFns } from "./PrimaryMenu.vue?vue&type=template&id=9c6d1430&scoped=true"
import script from "./PrimaryMenu.vue?vue&type=script&lang=ts"
export * from "./PrimaryMenu.vue?vue&type=script&lang=ts"
import style0 from "./PrimaryMenu.vue?vue&type=style&index=0&id=9c6d1430&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6d1430",
  null
  
)

export default component.exports